import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';

import {
	Container,
	Image,
	ImageDetailsContainer,
	ImageDetail
} from './styles';

// These are the only types that can be printed automatically
const imageTypes = [
	'jpg', 'jpeg', 'gif', 'svg', 'png'
];

const ViewImage = props => {
	if (!props.image) {
		return null;
	}

	const smallUrl = props.image ? props.image.conversions.min : '';
	const largeUrl = props.image ? props.image.conversions.large : '';

	const { t } = props;

	const fileType = (props.image && props.image.href) ? props.image.href.split('.').pop() : false;
	const canPrintImage = imageTypes.includes(fileType);

	return (
		<Container onClick={props.closeHandler}>
			<Image style={{ backgroundImage: `url(${largeUrl}), url(${smallUrl})` }}>
				<ImageDetailsContainer>
					<ImageDetail href={props.image.href} target="_blank">
						<Icon icon="photo" className="icon" /> {props.image.name}
					</ImageDetail>
					{canPrintImage ? <ImageDetail href={props.image.print_url} target="_blank">
						<Icon icon="printer" /> {t('building/images/print')}
					</ImageDetail> : null}
				</ImageDetailsContainer>
			</Image>
		</Container>
	)
};

ViewImage.propTypes = {
	image: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
	closeHandler: PropTypes.func,
}

export default ViewImage
